<template>
    <div>
        <RsStep :active="2" :steps="['创建专辑', '上传歌曲', '提交审核']"></RsStep>
        <div class="content-box first">
            <el-result icon="success" title="已成功提交审核" subTitle="我们将在3-5个工作日内完成审核">
                <template slot="extra">
                    <el-button @click="$router.push({ path: '/manage/album/list' })" type="info">{{ timeCount }}s
                        返回列表</el-button>
                </template>
            </el-result>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            timeCount: 5, // 5秒计时器
        };
    },
    mounted() {
        this.setTimeJump();
    },
    methods: {
        setTimeJump() {
            const timeInterval = setInterval(() => {
                this.timeCount -= 1;
                if (this.timeCount <= 0) {
                    clearInterval(timeInterval);
                    this.$router.push({ path: '/manage/album/list' });
                }
            }, 1000)
        }
    },
};
</script>
